export default __webpack_public_path__ + "static/media/1star.617ab0d6.png";